<template>
  <div id="roleTemplateList" v-ripple :class="{selected: showSelected}">
    <template v-if="roleTemplate">
      <div class="name">{{ roleTemplate.title }}</div>
    </template>
  </div>
</template>

<script>

  import ListItemMixin from '../mixins/listItemMixin.js' 

  export default {
    mixins: [ListItemMixin],
    data () {
      return {

      }
    },
    computed: {
      roleTemplate () {
        return this.$store.getters.roleTemplate(this.item);
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #roleTemplateList {
    
    @include fontPrimary400();

    display: block;
    position: relative;
    width: 100%;
    height: 52px;
    border-bottom: 1px solid $black12;
    background: $white;

    &.selected {
      background: $lightGreen;
    }

    .name {
      @include fontPrimary400;
      @include textEllipsis;
      
      position: absolute;
      top: 16px;
      left: 16px;
      right: 16px;
    }


  }

</style>


// WEBPACK FOOTER //
// src/components/RoleTemplateList.vue